export const NOTIFICATION_OPTIONS = [
	{ label: "Aviso de bloqueio", value: "block_warning" },
	{ label: "10 dias de inadimplência", value: "ten_days_delinquency_notication" },
	{ label: "Acesso desbloqueado", value: "unlocked-access" },
	{ label: "30 dias de inatividade", value: "inactivity-thirty-days" },
	{ label: "Aviso de retorno de cancelamento", value: "cancel-return-notification" },
	{ label: "Aviso para aceitar novos Termos de Uso", value: "terms-of-service-notification" }
] as const

export type NotificationTypes = typeof NOTIFICATION_OPTIONS[number]["value"];
